import request from '@/utils/http.js';
import env from '../../env';

/**
 * 发送公告消息
 * */
function sendNotice(params = {}) {
  const url = '/v3/interacts/chat/send-notice-message';

  console.log('params:', params);

  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 获取公告列表
 * */
function getNoticeList(params = {}) {
  const url = '/v3/interacts/chat/get-announcement-list';

  return request({
    url,
    method: 'POST',
    data: params
  });
}
function setNotice(params = {}) {
  const url = '/v3/interacts/chat/set-notice-config';

  return request({
    url,
    method: 'POST',
    data: params
  });
}

function delNotice(params = {}) {
  const url = '/v3/interacts/chat/del-announcement';

  return request({
    url,
    method: 'POST',
    data: params
  });
}
export default {
  sendNotice,
  getNoticeList,
  setNotice,
  delNotice
};
